export default function EFLaptop(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76" fill="none" {...props}>
            <path
                d="M15.5337 52.6686V24.3584C15.5337 24.0482 15.5949 23.741 15.7138 23.4545C15.8327 23.168 16.007 22.9077 16.2267 22.6887C16.4464 22.4696 16.7071 22.296 16.9939 22.1779C17.2808 22.0598 17.5882 21.9995 17.8984 22.0003H57.9857C58.2987 21.9951 58.6096 22.0522 58.9003 22.1683C59.191 22.2845 59.4556 22.4573 59.6788 22.6768C59.902 22.8963 60.0792 23.1581 60.2002 23.4468C60.3212 23.7355 60.3835 24.0454 60.3834 24.3584V52.6686"
                stroke="white"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M12.0264 52.6685H63.8579V54.2075C63.8579 54.4177 63.7744 54.6193 63.6257 54.768C63.4771 54.9166 63.2755 55.0001 63.0653 55.0001H12.7926C12.5824 55.0001 12.3808 54.9166 12.2322 54.768C12.0835 54.6193 12 54.4177 12 54.2075V52.6949L12.0264 52.6685Z"
                stroke="white"
                strokeWidth="1.3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M57.9792 24.3652H17.8853V50.3107H57.9792V24.3652Z" stroke="white" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <circle cx="38" cy="38" r="37" stroke="white" strokeWidth="2" />
        </svg>
    );
}
